import React from "react";
import { Clock3, MapPin, AlertTriangle } from "lucide-react";
import { LotesRoteirizacaoResponse } from "../../../services/roteirizacaoService";

interface CapacidadeBannerProps {
  data: LotesRoteirizacaoResponse | undefined;
}

const CapacidadeBanner: React.FC<CapacidadeBannerProps> = ({ data }) => {
  if (!data) return null;

  const {
    capacidade,
    distanciaMaximaCasamentoKm,
    aguardarCasamentoMinutos,
    distanciaModoLabel,
    totais,
    roteirizacaoAutomaticaAtiva,
  } = data;

  return (
    <div className="space-y-2">
      {!roteirizacaoAutomaticaAtiva && (
        <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          <p>
            A flag <strong>Roteirização automática</strong> desta loja está
            desativada no cadastro. O matching ainda funciona; ative em Lojas
            quando for usar em operação.
          </p>
        </div>
      )}

      <div className="flex flex-wrap items-center gap-3 rounded-lg border border-primary/20 bg-primary-light/10 px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-primary">
          <Clock3 size={16} />
          Agora {capacidade.horarioLabel}
          {capacidade.foraDaJanela ? " (fora da janela)" : ""}
        </div>
        <span className="rounded-full bg-white px-3 py-1 text-sm font-bold text-neutral-800 shadow-sm">
          Até {capacidade.maxComandas} comanda
          {capacidade.maxComandas !== 1 ? "s" : ""} por lote
        </span>
        <span className="flex items-center gap-1 rounded-full bg-white px-3 py-1 text-sm font-medium text-neutral-700 shadow-sm">
          <MapPin size={14} />
          Raio {distanciaMaximaCasamentoKm} km
          {distanciaModoLabel ? ` · ${distanciaModoLabel}` : ""}
        </span>
        {aguardarCasamentoMinutos != null && (
          <span className="rounded-full bg-white px-3 py-1 text-sm font-medium text-neutral-700 shadow-sm">
            Espera {aguardarCasamentoMinutos} min p/ casar
          </span>
        )}
        <span className="text-xs text-neutral-600">
          {totais.prontos} prontos · {totais.elegiveis} com localização ·{" "}
          {totais.semLocalizacao} sem geo · {totais.lotes} lotes
        </span>
      </div>
    </div>
  );
};

export default CapacidadeBanner;
